import { TextField as AriaTextField, type TextFieldProps as AriaTextFieldProps, TextArea } from 'react-aria-components';

import Field, { type FieldBaseProps } from './Field.tsx';

export interface TextFieldProps extends Omit<AriaTextFieldProps, 'value' | 'onChange' | 'className'>, FieldBaseProps {
    value?: string | null;
    onChange?: (value: string) => void;
    rows?: number;
}

// Multi-line text input; single-line text is StringField.
const TextField = ({
    label,
    helpText,
    errorMessage,
    placeholder,
    labelAccessory,
    rows = 3,
    className,
    isRequired,
    value,
    ...props
}: TextFieldProps) => (
    <Field className={className}>
        <AriaTextField
            {...props}
            value={value === undefined ? undefined : (value ?? '')}
            isRequired={isRequired}
            isInvalid={props.isInvalid || !!errorMessage}
        >
            <Field.Header label={label} labelAccessory={labelAccessory} isRequired={isRequired} />
            <Field.Input isInvalid={props.isInvalid || !!errorMessage} className="h-auto py-2.5">
                <TextArea placeholder={placeholder} rows={rows} className="resize-y" />
            </Field.Input>
            <Field.Footer helpText={helpText} errorMessage={errorMessage} />
        </AriaTextField>
    </Field>
);

export default TextField;
